import { json } from 'react-router-dom';
import fetchData from 'services/fetchData';

export async function commonLoader({ params, apiEndpoints, isStatic = false }) {
  const { id } = params; // Assuming 'params' is provided

  // If there's no API endpoint, return early (useful for static routes)
  if (!apiEndpoints) {
    return null;
  }

  // Proceed with API call if permission check passes and apiEndpoints is provided
  try {
    const response = await fetchData(apiEndpoints(id), { isStatic }); // API call with dynamic endpoint

    if (response.code === 200) {
      if (!response.status) {
        throw new Response('Failed to fetch data', { status: 500 });
      } else {
        const commonData = response.data;
        return commonData; // Return the fetched data if successful
      }
    } else if (response.code === 500) {
      throw new Response('Internal Server Error. Failed to fetch data.', {
        status: 500
      });
    } else if (response.code === 400) {
      throw new Response('Bad Request. Invalid data provided.', {
        status: 400
      });
    } else if (response.code === 403) {
      throw new Response(
        'Access Forbidden! you are not authorize to access this page.',
        { status: 403 }
      );
    } else if (!response.code) {
      throw new Response('Unknown error occurred.', { status: 500 });
    }
  } catch (error) {
    throw json({ message: error.message }, { status: error.status || 500 });
  }
}
